angular.module('unica_feedback.feedback_services')

.factory('FeedbackListService', function ($http, getBaseApiURL, $rootScope) {

	var feedbackListService = {};

	feedbackListService.list = function (categoryId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback/list/' + categoryId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.feedbackList;
			}

		});

	};

	feedbackListService.get = function (feedbackId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback/detail/' + feedbackId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.feedback;
			}

		});

	};

	feedbackListService.exportFeedbackCategory = function (categoryId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/feedback-category/' + categoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};

	feedbackListService.exportAudioZip = function ( eventId, categoryId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/feedback-audio/' + eventId + '/' + categoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				if ( result.data.result == 'ok' ) {
					return result.data.url;
				} else {
					$rootScope.showWarningMsg( result.data.message );
				}
			}

		});
	};

	return feedbackListService;
});